import "core-js/modules/es.array.find-index";
import "core-js/modules/es.array.slice";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Avatar from '@vip-activity/ui/components/Avatar/Avatar.vue';
import { VIPICON } from '@/util/constant';
import Bus from '@/util/eventBus';
var placeHolder = {
  isPlaceHolder: true,
  imgUrl: '',
  level: '0',
  totalTicketNum: 0,
  userName: ''
};
export default {
  props: {
    list: {
      Array: Array,
      default: function _default() {
        return [];
      }
    },
    isRankEnd: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    fansList: function fansList() {
      if (this.list.length < 3) {
        var list = this.list.slice(); // eslint-disable-next-line no-plusplus

        for (var i = 0; i < 3 - this.list.length; i++) {
          list.push(placeHolder);
        }

        return list;
      }

      return this.list;
    },
    buyList: function buyList() {
      return this.$store.state.buyList;
    },
    myRank: function myRank() {
      var vuid = this.userService.vuid;

      if (vuid) {
        var me = this.fansList.findIndex(function (item) {
          return item.vuid === String(vuid);
        });

        if (me > -1) {
          return me + 1;
        }

        return '99+';
      }

      return '-';
    }
  },
  methods: {
    levelIcon: function levelIcon(level) {
      return +level > 0 ? VIPICON[level] : '';
    },
    share: function share() {
      Bus.$emit('launchShare', {
        type: 0,
        num: this.selfTicketCount || 1,
        sendDesc: this.selfTicketCount ? '已支持' : '已获得'
      });
    }
  },
  components: {
    Avatar: Avatar
  }
};